var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-table"},[_c('ag-grid-vue',{staticClass:"userTable wk-advanced-table wk-is-striped",attrs:{"column-defs":_vm.columnDefs,"row-data":_vm.rowData,"grid-options":_vm.gridOptions,"enable-col-resize":true,"pagination":_vm.pagination,"pagination-page-size":this['users/paginationPageSize']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }